import { usePostHog } from "@posthog/react";
import { isPostHogEnabled } from "@/utils/posthog_config";

export function useSafePostHog() {
  const posthog = usePostHog();
  return isPostHogEnabled() ? posthog : null;
}
